<template>
  <div class="tw:bg-blue-700/5 tw:border tw:border-blue-700/20 tw:rounded-lg tw:p-4 tw:mb-2">
    <div class="tw:flex tw:flex-row tw:gap-x-2 tw:mb-2.5">
      <img :src="GrowthIcon" alt="Icon" />
      <h4 class="tw:font-bold" :class="{ 'tw:text-nowrap': language === 'ja-JP' }">
        {{ $t('tbs_images_data_header') }}
      </h4>
    </div>
    <ul class="tw:flex tw:flex-col tw:gap-y-2 tw:mb-2.5">
      <li v-for="(insight, index) in insights" :key="index" v-html="$t(insight)" class="tw:text-sm" />
    </ul>
    <div>
      <p class="tw:text-xs tw:text-gray-600">{{ $t('tbs_images_data_source') }}</p>
    </div>
  </div>
</template>
<script setup>
import { useSessionValues } from '@/composables/useSessionValues'

const GrowthIcon = new URL(`../../../assets/img/property-details/property-images/GrowthIcon.svg`, import.meta.url)

const { language } = useSessionValues()
const insights = ['tbs_images_data_point_1', 'tbs_images_data_point_2', 'tbs_images_data_point_3']
</script>
<style scoped>
li :deep(span) {
  font-weight: bold;
  color: var(--tw-color-blue-700);
  font-size: 14px;
}
</style>
